import React,{Component} from "react"
import { Form, Icon, Input, Button, Row, Col, Select,Checkbox } from 'antd';
const FormItem = Form.Item;
const { Option } = Select;
class Signupcard extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          firstName: '',
          plan:"free",
          lastName: '',
          email: '',
          password: '',
          role: 'student',
          card:{},
          subscription:{},
          loading: false,
          tos:true,
          status: {
            completed: false
          },
          current_period_end:null
        };
        this.handleSelectChange = this.handleSelectChange.bind(this);
      }
      

    // componentWillReceiveProps(nextProps) {
    //   const { authError, authSuccess } = nextProps;
    //   if (authError) message.error(authError);
    //   if(authSuccess === SIGNUP_SUCCESS_MSG) {
    //     message.success(authSuccess)
    //     ReactGA.event({
    //       category: 'User',
    //       action: 'Complete Registration',
    //       label: 'User Interaction'
    //     });
    //   }
    // } 
    
    handleChange(e) {
    if(e.target.name === "tos")return this.setState({[e.target.name]: e.target.checked})

        this.setState({ [e.target.name]: e.target.value });
      }
      handleSelectChange(value) {
        this.setState({ role: value });
      }
    
      handleSubmit(e) {
        e.preventDefault();
    
        this.props.form.validateFields((err) => {
          if (!err) {
            this.props.signUp(this.state);
          }
        });
      }
    render(){
    const { getFieldDecorator } = this.props.form;
        return(
            <div className="signupcard">
                <div className="xcard">
                <Form 
                  className="signup-form"
                  onSubmit={(e) => {
                    this.handleSubmit(e);
                  }}
                >
                  <div className="xheader">
                  <h5>Create Your Free Account</h5>
                  </div>
                  <Row gutter={8}>
                      <Col span={12}>
                      <FormItem >
                    {getFieldDecorator('firstName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your first name'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="firstName"
                        placeholder="First Name"
                      />
                    )}
                  </FormItem>
                      </Col>
                      <Col span={12}>
                      <FormItem>
                    {getFieldDecorator('lastName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your last name'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="lastName"
                        placeholder="Last Name"
                      />
                    )}
                  </FormItem>

                      </Col>
                </Row>

                <Form.Item >
                    {getFieldDecorator('select', {
                      rules: [
                        { required: true, message: 'Please select your role!'  }
                      ], initialValue:'student'
                     
                    })(
                      <Select  onChange={this.handleSelectChange}>
                        <Option value="student">Student</Option>
                        {/* <Option disabled value="teacher">Teacher</Option> */}
                      </Select>
                    )}
                  </Form.Item>
                  <FormItem>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your email'
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid email'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="mail"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="email"
                        placeholder="Email"
                      />
                    )}
                  </FormItem>
                  <FormItem style={{margin:0}}>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password'
                        },
                        {
                          min: 6,
                          message: 'Password should be at least 6 characters'
                        }
                      ]
                    })(
                      <Input.Password
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="lock"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="password"
                        type="password"
                        placeholder="Password"
                      />
                    )}
                  </FormItem>
                  <Form.Item style={{margin:0}}>
                    {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                    })(<Checkbox name="tos" onChange={e => this.handleChange(e)}>I agree to Terms & Conditions and Privacy Policy</Checkbox>)}
                    </Form.Item>
                  
                  <FormItem>
                      {this.props.loading?
                        <Button disabled={!this.state.tos}  block type="primary" htmlType="submit" className="xpad-btn">
                        <Icon type="loading" style={{ fontSize: 15 }} spin /> 
                        </Button>
                      :
                    <Button disabled={!this.state.tos}  block type="primary" htmlType="submit" className="xpad-btn">
                      SIGN UP
                    </Button>}
                  </FormItem>
                </Form>
                </div>
            </div>
        )
    }
}

const WrappedSignupForm = Form.create()(Signupcard);
export default WrappedSignupForm;